import type {Result} from 'framework';
import type {SignInWithEmail} from '../application/use-cases/sign-in-with-email';
import type {SignUpWithEmail} from '../application/use-cases/sign-up-with-email';
import type {ChangePassword} from '../application/use-cases/change-password';
import type {RequestPasswordReset} from '../application/use-cases/request-password-reset';
import type {ResetPassword} from '../application/use-cases/reset-password';
import type {SignOut} from '../application/use-cases/sign-out';
import type {GetSession} from '../application/use-cases/get-session';
import type {
  ChangePasswordData,
  RequestPasswordResetData,
  ResetPasswordData,
  SignInWithEmailData,
  SignUpWithEmailData,
} from '../application/ports/auth.repository';
import type {Session} from '../domain/session';
import type {
  ChangePasswordError,
  GetSessionError,
  RequestPasswordResetError,
  ResetPasswordError,
  SignInError,
  SignOutError,
  SignUpError,
} from '../domain/errors';

export class AuthController {
  constructor(
    private readonly signInWithEmailUseCase: SignInWithEmail,
    private readonly signUpWithEmailUseCase: SignUpWithEmail,
    private readonly changePasswordUseCase: ChangePassword,
    private readonly requestPasswordResetUseCase: RequestPasswordReset,
    private readonly resetPasswordUseCase: ResetPassword,
    private readonly signOutUseCase: SignOut,
    private readonly getSessionUseCase: GetSession,
  ) {}

  signInWithEmail(data: SignInWithEmailData): Promise<Result<Session, SignInError>> {
    return this.signInWithEmailUseCase.execute(data);
  }

  signUpWithEmail(data: SignUpWithEmailData): Promise<Result<Session, SignUpError>> {
    return this.signUpWithEmailUseCase.execute(data);
  }

  changePassword(data: ChangePasswordData): Promise<Result<undefined, ChangePasswordError>> {
    return this.changePasswordUseCase.execute(data);
  }

  requestPasswordReset(
    data: RequestPasswordResetData,
  ): Promise<Result<undefined, RequestPasswordResetError>> {
    return this.requestPasswordResetUseCase.execute(data);
  }

  resetPassword(data: ResetPasswordData): Promise<Result<undefined, ResetPasswordError>> {
    return this.resetPasswordUseCase.execute(data);
  }

  signOut(): Promise<Result<undefined, SignOutError>> {
    return this.signOutUseCase.execute();
  }

  getSession(): Promise<Result<Session | null, GetSessionError>> {
    return this.getSessionUseCase.execute();
  }
}
